import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class LoaderComponent {}
